import { render, staticRenderFns } from "./LogHoursDeclined.vue?vue&type=template&id=799cfa2b&"
import script from "./LogHoursDeclined.vue?vue&type=script&lang=js&"
export * from "./LogHoursDeclined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports